import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useGA4Tracking(measurementId) {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', measurementId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, measurementId]);
}
